export const TOAST_TIMEOUT = 4000; //in milliseconds.
export const RESEND_OTP_TIME = 60; //in seconds
export const GET_VM_POLLING_TIME = 15000;
export const OTP_LENGTH = 4;
export const RAZORPAY_SCRIPT_URL =
  "https://checkout.razorpay.com/v1/checkout.js";
export const PAYTM_SCRIPT_URL =
  "https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/qZpxzj74834207185485.js";

export const ENV_CONFIGS = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT, //REACT_APP is a must prefix to enable environment variables
  RAZORPAY_KEY: process.env.REACT_APP_RAZORPAY_KEY,
  PAYTM_MERCHANT_ID: process.env.REACT_APP_PAYTM_MERCHANT_ID,
};

export const COOKIE_EXPIRATION_DAYS = 365;

export const API_METHODS = {
  POST: "POST",
};

export const ELEMENTS_TAG_NAME = {
  BODY: "BODY",
  BUTTON: "BUTTON",
};

export const REDUX_ACTIONS = {
  FETCH_VM_DETAILS: Symbol.for("FETCH_VM_DETAILS"),
  RESET_VM_DETAILS: Symbol.for("RESET_VM_DETAILS"),
  FETCH_CL_DETAILS: Symbol.for("FETCH_CL_DETAILS"),
  RESET_CL_DETAILS: Symbol.for("RESET_CL_DETAILS"),
  DUMMY_ACTION: Symbol.for("DUMMY_ACTION"),
  FETCH_VM_STOCK: Symbol.for("FETCH_VM_STOCK"),
  RESET_VM_STOCK: Symbol.for("RESET_VM_STOCK"),
  ADD_ITEMS_TO_CART: Symbol.for("ADD_ITEMS_TO_CART"),
  RESET_CART: Symbol.for("RESET_CART"),
  PUSH_COUPON_CODE_TO_CART: Symbol.for("PUSH_COUPON_CODE_TO_CART"),
  CREATE_CART_UNIQUE_ID: Symbol.for("CREATE_CART_UNIQUE_ID"),
  RESET_CART_UNIQUE_ID: Symbol.for("RESET_CART_UNIQUE_ID"),
  PUSH_FILTERED_VM_ITEMS: Symbol.for("PUSH_FILTERED_VM_ITEMS"),
};

export const CURRENCIES = {
  RUPEES: "₹",
};

export const LOCAL_STORAGE_IDS = {
  VENDING_MACHINE_ID: "VENDING_MACHINE_ID",
  USER_TOKEN: "USER_TOKEN",
  USER_HASH_TOKEN: "USER_HASH_TOKEN",
  USER_ID: "USER_ID",
  USER_PH: "USER_PH",
  CART_CACHE: "CART_CACHE",
};

export const STATUS_CODES = {
  VM_NOT_FOUND: 400,
};

export const KEY_CODES = {
  BACKSPACE: "Backspace",
};

export const ASCII_CODES = {
  NUMBERS: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57],
};

export const STD_CODES = {
  INDIA: "+91",
};

export const PAYMENT_METHODS = {
  CARD: { id: 0, code: "card" },
  UPI: { id: 1, code: "upi" },
  WALLET: { id: 2, code: "wallet" },
};

export const VM_NOT_FOUND_MSG = "Vending Machine not found.";

export const DISCOUNT_TYPES = {
  FLAT: 1,
  PERCENTAGE: 2,
  BUY_X_GET_Y: 3,
  BUY_X_FOR_Y: 4,
};

export const PRODUCTS_FILTER_TYPE = {
  OTHERS: "other_filter",
  BRANDS: "brand_filter",
  CATEGORY: "category_filter",
};

export const SERVER_TYPES = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
};

export const VM_STATUS_ONLINE = {
  TITLE: "Oops",
  DESCRPTION:
    "Machine is not connected to the internet, please try again later",
};
export const VM_PRODUCTS_NOT_AVAILABLE = {
  TITLE: "Oops",
  DESCRPTION:
    "No more active offers at this moment, please check back for more offers weekly.",
};
